import { AxiosError } from 'axios';

export const getAxiosErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (error instanceof AxiosError && error.response?.data?.message) {
    return error.response.data.message;
  }

  return fallback;
};
